// Lib
import React, { FC } from 'react';

// Util
import { registerDownloadSource } from '../../../../utils/fileDownloader/javascriptToSwiftFileDownloads';

// Components
import ModalToolbarButton from './ModalToolbarButton';
import DownloadButton from '../../../../components/buttons/DownloadButton';
import Icon from '../../../../components/icons/Icon';

// Styles
import './ModalToolbarDownloadButton.scss';

type ModalToolbarDownloadButtonProps = {
    url: string;
    filename: string;
    elementId: string;
};

const ModalToolbarDownloadButton: FC<ModalToolbarDownloadButtonProps> = ({ children, ...props }) => {
    return (
        <ModalToolbarButton className="ModalToolbarDownloadButton">
            <DownloadButton
                {...props}
                onDownloadStart={() => registerDownloadSource('.ModalToolbarDownloadButton')}
                isShare={false}
            >
                <Icon name="modal-toolbar-download" />
                <div className="text">{children}</div>
            </DownloadButton>
        </ModalToolbarButton>
    );
};

export default ModalToolbarDownloadButton;
